import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';

import type { CreateAccountFormState } from './hooks';
import { Region } from './hooks/useCreateAccount';

type RegionSectionProps = {
  form: CreateAccountFormState;
};

export const RegionSection = ({ form }: RegionSectionProps) => {
  const { accountDetails, setField } = form;

  return (
    <>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Choose where your data is stored to comply with data regulations. This
        can't be changed later. If unsure, select EU.
      </Typography>
      <FormControl component="fieldset">
        <RadioGroup
          aria-label="region"
          name="region"
          value={accountDetails.region}
          onChange={(_e, region) => setField({ region: region as Region })}
        >
          <FormControlLabel
            value={Region.RegionEu}
            control={<Radio color="primary" />}
            label="EU"
          />
          <FormControlLabel
            value={Region.RegionUs}
            control={<Radio color="primary" />}
            label="US"
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};
